import styled from "styled-components";

const CategoriesContainer = styled.section`
    margin-bottom: 50px;
    @media screen (max-width: 768px) {
        margin-bottom: 20px;
    }
    .page-title {
        margin-bottom: 30px;
    }

    .product-list {
        .item {
            margin-bottom: 15px;
            .cat-name {
                color: #333;
            }
            &:hover {
                .cat-name {
                    color: #000;
                }
            }


            .img-sec-outer {
                position: relative;
                padding-bottom: 100%;
                .img-sec {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    height: 100%;
                    width: 100%;
                    &:not(.loaded) {
                        background: #efefef;
                    }
                }
            }
        }
    }
`

export default CategoriesContainer;